import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { AiFillEdit } from "react-icons/ai";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal, Form, Input, Button, Select } from "antd";
import { Link, useParams } from "react-router-dom";
import AdminNav from "./AdminNav";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { currencyOptions, crptoOptionsFlag } from "./currencyOptions";

const UserDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userData, setUserData] = useState({});
  const [banks, setBanks] = useState([]);
  const [wallets, setWallets] = useState([]);
  const [email, setEmail] = useState("");
  const [baseCurrency, setBaseCurrency] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentEditSection, setCurrentEditSection] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    gender: "",
    country: "",
    street: "",
    city: "",
    state: "",
    postal: "",
    address: "",
  });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const token = localStorage.getItem("admintoken");

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/auth/get-user-data/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (data?.success) {
          setUserData(data?.details || {});
          setEmail(data?.email || "");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchUserBanks = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/bank/get-banks/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (data?.success) {
          setBanks(data?.banks || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchUserWallets = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/wallet/get-wallets/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (data?.success) {
          setWallets(data?.wallets || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchBaseCurrency = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/wallet/get-currency/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (data?.success) {
          setBaseCurrency(data?.currency?.currency || "");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
    fetchUserBanks();
    fetchUserWallets();
    fetchBaseCurrency();
  }, [id, token]);

  const openModal = (section) => {
    setCurrentEditSection(section);
    setFormData({
      id: userData?._id || "",
      firstName: userData?.firstName || "",
      lastName: userData?.lastName || "",
      email: email || "",
      phone: userData?.phone || "",
      gender: userData?.gender || "",
      country: userData?.country || "",
      street: userData?.street || "",
      city: userData?.city || "",
      state: userData?.state || "",
      postal: userData?.postal || "",
      address: userData?.address || "",
    });
    setIsModalVisible(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/auth/update-profile-user/${id}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (data?.success) {
        toast.success("Profile updated successfully");
        setUserData(data?.details || {});
        setEmail(data?.email || "");
        setIsModalVisible(false);
      } else {
        toast.error(data?.message || "Update failed");
      }
    } catch (error) {
      console.log(error);
      toast.error("An error occurred during update");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e?.target || {};
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleGenderChange = (value) => {
    setFormData({
      ...formData,
      gender: value || "",
    });
  };

  const groupedWallets =
    wallets?.reduce((acc, wallet) => {
      const { asset, network } = wallet || {};
      if (!acc[asset]) {
        acc[asset] = { asset, networks: [] };
      }
      acc[asset].networks.push(network);
      return acc;
    }, {}) || {};

  const selectedCurrency = currencyOptions?.find(
    (option) => option?.value === baseCurrency
  );

  const getAssetFlag = (asset) => {
    if (!asset) return null;
    const baseAsset = asset?.split("-")[0];
    const assetData = crptoOptionsFlag?.find(
      (option) => option?.value === baseAsset
    );
    const flag = crptoOptionsFlag?.find(
      (item) => item?.value === asset || item?.value === baseAsset
    )?.flag;
    return assetData ? assetData.flag : null;
  };

  return (
    <>
      {loading && <Loader />}
      <div className="wrapper d-flex align-items-stretch">
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
        <div id="content" className="px-2">
          <button
            type="button"
            id="openSidebar"
            onClick={toggleSidebar}
            className="bars-btn"
          >
            <FaBarsStaggered />
          </button>
          <AdminNav />
          <div className="user-profile-main">
            <div className="user-details-card">
              <h4 className="pb-3">Personal Information</h4>
              <div className="user-personal-main">
                <div className="">
                  <div className="user-personal-main-left">
                    <div className="">
                      <h6 className="user-profil-text">First Name</h6>
                      <h4 className="user-profile-sm-text">
                        {userData?.firstName || "N/A"}
                      </h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">Last Name</h6>
                      <h4 className="user-profile-sm-text">
                        {userData?.lastName || "N/A"}
                      </h4>
                    </div>
                  </div>
                  <div className="user-personal-main-left">
                    <div className="">
                      <h6 className="user-profil-text">Email address</h6>
                      <h4 className="user-profile-sm-text">{email || "N/A"}</h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">Phone</h6>
                      <h4 className="user-profile-sm-text">
                        {userData?.phone || "N/A"}
                      </h4>
                    </div>
                  </div>
                  <div className="user-personal-main-left mb-0">
                    <div className="">
                      <h6 className="user-profil-text">Gender</h6>
                      <h4 className="user-profile-sm-text">
                        {userData?.gender || "N/A"}
                      </h4>
                    </div>
                  </div>
                </div>

                <div className="user-personal-main-right">
                  <button
                    className="user-profile-edit-btn"
                    onClick={() => openModal("personalInfo")}
                  >
                    Edit <AiFillEdit />
                  </button>
                </div>
              </div>
            </div>

            <div className="user-details-card">
              <h4 className="pb-3">Address</h4>
              <div className="user-personal-main">
                <div className="">
                  <div className="user-personal-main-left">
                    <div className="">
                      <h6 className="user-profil-text">Country</h6>
                      <h4 className="user-profile-sm-text">
                        {userData?.country || "N/A"}
                      </h4>
                    </div>
                    <div className="">
                      <h6 className="user-profil-text">City/State</h6>
                      <h4 className="user-profile-sm-text">
                        {`${userData?.city || ""}${
                          userData?.city && userData?.state ? " , " : ""
                        }${userData?.state || ""}` || "N/A"}
                      </h4>
                    </div>
                  </div>
                  <div className="user-personal-main-left">
                    <div className="">
                      <h6 className="user-profil-text">Postal Code</h6>
                      <h4 className="user-profile-sm-text">
                        {userData?.postal || "N/A"}
                      </h4>
                    </div>
                  </div>
                  <div className="user-personal-main-left mb-0">
                    <div className="">
                      <h6 className="user-profil-text">Street Address</h6>
                      <h4 className="user-profile-sm-text">
                        {`${userData?.street || ""} ${
                          userData?.address || ""
                        }`.trim() || "N/A"}
                      </h4>
                    </div>
                  </div>
                </div>

                <div className="user-personal-main-right">
                  <button
                    onClick={() => openModal("addressInfo")}
                    className="user-profile-edit-btn"
                  >
                    Edit <AiFillEdit />
                  </button>
                </div>
              </div>
              <Modal
                title={
                  currentEditSection === "personalInfo"
                    ? "Personal Info"
                    : "Address Info"
                }
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={[
                  <Button key="cancel" onClick={() => setIsModalVisible(false)}>
                    Cancel
                  </Button>,
                  <Button key="save" type="primary" onClick={handleSave}>
                    Save Changes
                  </Button>,
                ]}
              >
                <Form layout="vertical" onFinish={handleSave}>
                  {currentEditSection === "personalInfo" && (
                    <>
                      <Form.Item label="First Name">
                        <Input
                          name="firstName"
                          value={formData?.firstName || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="Last Name">
                        <Input
                          name="lastName"
                          value={formData?.lastName || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="Email Address">
                        <Input
                          name="email"
                          value={formData?.email || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="Phone">
                        <Input
                          name="phone"
                          value={formData?.phone || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="Gender">
                        <Select
                          value={formData?.gender || ""}
                          onChange={handleGenderChange}
                          placeholder="Select Gender"
                        >
                          <Select.Option value="male">Male</Select.Option>
                          <Select.Option value="female">Female</Select.Option>
                        </Select>
                      </Form.Item>
                    </>
                  )}

                  {currentEditSection === "addressInfo" && (
                    <>
                      <Form.Item label="Street Address">
                        <Input
                          name="street"
                          value={formData?.street || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="Address">
                        <Input
                          name="address"
                          value={formData?.address || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="Postal Code">
                        <Input
                          name="postal"
                          value={formData?.postal || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="City">
                        <Input
                          name="city"
                          value={formData?.city || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                      <Form.Item label="State">
                        <Input
                          name="state"
                          value={formData?.state || ""}
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </>
                  )}
                </Form>
              </Modal>
            </div>

            <div className="user-details-card">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Banks Details</h4>
                <Link
                  to={`/dashboard/admin/add-bank/${id}`}
                  className="btn btn-primary"
                >
                  Add New Bank
                </Link>
              </div>
              <div className="tbl-main">
                <table className="simple-table">
                  <thead>
                    <tr>
                      <th>Bank Name</th>
                      <th className="text-end">Bank Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {banks?.length > 0 ? (
                      banks?.map((bank) => (
                        <tr key={bank?._id}>
                          <td>{bank?.bankName || "N/A"}</td>
                          <td className="text-end">
                            <Link
                              to={`/dashboard/admin/user-details/bank/${bank?._id}`}
                              className="btn btn-primary"
                            >
                              Details
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">No Banks found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="user-details-card">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Wallet Address</h4>
                <Link
                  to={`/dashboard/admin/add-wallet/${id}`}
                  className="btn btn-primary"
                >
                  Add New Wallet Address
                </Link>
              </div>
              <div className="tbl-main">
                <table className="simple-table">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Networks</th>
                      <th className="text-end">Wallet Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(groupedWallets)?.length > 0 ? (
                      Object.values(groupedWallets)?.map((group) => (
                        <tr key={group?.asset}>
                          <td>
                            {(() => {
                              const flag = getAssetFlag(group?.asset);
                              if (flag) {
                                return (
                                  <img
                                    src={flag}
                                    alt={group?.asset}
                                    style={{
                                      width: "20px",
                                      marginRight: "5px",
                                    }}
                                  />
                                );
                              }
                              return null;
                            })()}
                            {group?.asset || "N/A"}
                          </td>
                          <td>
                            {group?.networks?.map((network, idx) => (
                              <span key={idx}>
                                {network || "N/A"}
                                <br />
                              </span>
                            ))}
                          </td>
                          <td className="text-end">
                            <Link
                              to={`/dashboard/admin/user-details/wallet?asset=${group?.asset}&id=${id}`}
                              className="btn btn-primary"
                            >
                              Details
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No Wallets Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="user-details-card">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Base Currency</h4>
                <Link
                  to={`/dashboard/admin/base-currency/${id}`}
                  className="btn btn-primary"
                >
                  Select Base Currency
                </Link>
              </div>
              {baseCurrency ? (
                <>
                  <h4
                    className="mt-4"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {selectedCurrency && (
                      <img
                        src={selectedCurrency?.flag}
                        alt={`${baseCurrency} flag`}
                        style={{ width: 35 }}
                      />
                    )}
                    {baseCurrency}
                  </h4>
                </>
              ) : (
                <h6 className="mt-3">No Currency Selected</h6>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDetails;
